import React from "react";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Style/CompanySettings.css";
import { path_url } from "../../Config/config";

const customerSchema = Yup.object().shape({
  duedate: Yup.string().required("Required"),
  subject: Yup.string().required("Required"),
});
const options = [
  { value: "option1", label: "Option 1" },
  { value: "option2", label: "Option 2" },
  { value: "option3", label: "Option 3" },
];

const Priority = [
  { value: "High" },
  { value: "Medium" },
  { value: "Low" },
  { value: "Critical" },
  { value: "Normal" },
  { value: "Emergency" },
  { value: "Deferred" },
];

const Enum = [
  { value: "Open" },
  { value: "InProgress" },
  { value: "Pending" },
  { value: "Completed" },
  { value: "Canceled" },
  { value: "Deferred" },
  { value: "WaitingforCustomer" },
  { value: "WaitingforInternalReview" },
  { value: "Reassigned" },
  { value: "OnHold" },
  { value: "Overdue" },
  { value: "Scheduled" },
  { value: "NeedsMoreInformation" },
  { value: "Escalated" },
  { value: "Closed" },
  { value: "NotApplicable" },
];

// Reduced weight applied only within .cs-shipping-section (see CompanySettings.css)
// so other Company Settings tabs keep their existing bold cs-label styling.
function FormLabel({ text, required }) {
  return (
    <label className="cs-label">
      {text}
      {required && <sup>*</sup>}
    </label>
  );
}

export default function Shipping() {
  return (
    <>
      <Formik
        initialValues={{
          duedate: "",
          subject: "",
          notes: "",
          assign: "",
          asignedto: "",
          priority: "",
          status: "",
        }}
        validationSchema={customerSchema}
        onSubmit={async (values) => {
          try {
            const token = localStorage.getItem("accessToken");
            const response = await axios.post(`${path_url}/task`, values, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            });
            if (response.data.statusCodeValue === 200) {
              alert("form submitted successfully");
            } else {
              toast.error(response.data.body);
            }
          } catch (errors) {
            console.log(errors);
          }

          console.log(values);
        }}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit} className="cs-shipping-section">
            <fieldset>
              <div className="cs-section-header">
                <p>Shipping</p>
              </div>

              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="cs-form-row">
                    <FormLabel text="Name" />
                    <div className="cs-field-wrap">
                      <input
                        className="cs-input"
                        type="text"
                        placeholder="Name"
                        name="subject"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.subject}
                      />
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Address" />
                    <div className="cs-field-wrap">
                      <input
                        className="cs-input"
                        type="text"
                        placeholder="Address"
                        name="subject"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.subject}
                      />
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Address 2" />
                    <div className="cs-field-wrap">
                      <input
                        className="cs-input"
                        type="text"
                        placeholder="Address 2"
                        name="subject"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.subject}
                      />
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Postal Code" />
                    <div className="cs-field-wrap">
                      <input
                        className="cs-input"
                        type="text"
                        placeholder=""
                        name="duedate"
                        value={formik.values.duedate}
                        onChange={formik.handleChange}
                      />
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Region" />
                    <div className="cs-field-wrap">
                      <Field
                        as="select"
                        name="priority"
                        id="priority"
                        className="cs-select"
                      >
                        <option value="Active">Select</option>
                        {Priority.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.value}
                          </option>
                        ))}
                      </Field>
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Contact" />
                    <div className="cs-field-wrap">
                      <input
                        className="cs-input"
                        type="text"
                        placeholder=""
                        name="duedate"
                        value={formik.values.duedate}
                        onChange={formik.handleChange}
                      />
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Location Code" />
                    <div className="cs-field-wrap">
                      <Field
                        as="select"
                        name="assignedto"
                        id="assignedto"
                        className="cs-select"
                      >
                        <option value="Mobile">John Red</option>
                        {options.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Field>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <div className="cs-form-row">
                    <FormLabel text="Responsibility Center" />
                    <div className="cs-field-wrap">
                      <Field
                        as="select"
                        name="assignedto"
                        id="assignedto"
                        className="cs-select"
                      >
                        <option value="Mobile">John Red</option>
                        {options.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Field>
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Check Availability Period" />
                    <div className="cs-field-wrap">
                      <input
                        className="cs-input"
                        type="text"
                        placeholder=""
                        name="duedate"
                        value={formik.values.duedate}
                        onChange={formik.handleChange}
                      />
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Check Availability Time Buffer" />
                    <div className="cs-field-wrap">
                      <Field
                        as="select"
                        name="assignedto"
                        id="assignedto"
                        className="cs-select"
                      >
                        <option value="Mobile">John Red</option>
                        {options.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Field>
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Base Calendar Code" />
                    <div className="cs-field-wrap">
                      <Field
                        as="select"
                        name="assignedto"
                        id="assignedto"
                        className="cs-select"
                      >
                        <option value="Mobile">John Red</option>
                        {options.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Field>
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Customized Calendar" />
                    <div className="cs-field-wrap">
                      <input
                        className="cs-input"
                        type="text"
                        placeholder=""
                        name="duedate"
                        value={formik.values.duedate}
                        onChange={formik.handleChange}
                      />
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Calendar Convergence Time" />
                    <div className="cs-field-wrap">
                      <input
                        className="cs-input"
                        type="text"
                        placeholder=""
                        name="duedate"
                        value={formik.values.duedate}
                        onChange={formik.handleChange}
                      />
                    </div>
                  </div>

                  <div className="cs-btn-row">
                    <button
                      type="button"
                      className="cs-btn-cancel"
                      onClick={() => formik.resetForm()}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="cs-btn-save">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </Formik>
    </>
  );
}